
export const euroFormater = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
  